import React from "react";

import { SOCIAL_LINKS } from "../../../lib/constants";

import { Container, Link, Icon } from "./styles";

const SocialLinks = ({ location, handleOpenLink, addLinks }) => {
  const visibleIcons = [
    ...SOCIAL_LINKS.filter((icon) => icon.showIn.includes(location)),
    ...(addLinks || []),
  ];

  return (
    <Container>
      {visibleIcons.map((link) => (
        <Link
          key={link.platform}
          onClick={link.onClick || (() => handleOpenLink(link.platform))}
        >
          <Icon src={link.iconSrc} alt={link.alt} width={link.iconWidth} />
        </Link>
      ))}
    </Container>
  );
};

export default SocialLinks;
